import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.enforce()
  }

  enforce() {
    const boxes = this.checkboxes
    const lock = boxes.filter(box => box.checked).length >= this.max

    boxes.forEach(box => {
      const disable = lock && !box.checked
      box.disabled = disable
      box.classList.toggle("disabled", disable)
    })
  }

  get max() {
    const value = Number(this.element.dataset.teamLimitMaxValue)
    return Number.isFinite(value) && value > 0 ? value : 2
  }

  get checkboxes() {
    return Array.from(this.element.querySelectorAll('input[type="checkbox"]'))
  }
}
